import { useEffect, useState } from "react";
import axios from "axios";

export default function MyTasks() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAppointments = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Not authenticated");
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tasks/assigned`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        setAppointments(res.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load appointments.");
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-4 bg-white shadow rounded mt-6">
      <h2 className="text-xl font-semibold mb-4">Completed Tasks</h2>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-600">{error}</p>}

      {!loading && !appointments.length && <p>No Tasks found.</p>}

      <ul className="space-y-3">
        {appointments.map(app => (
          <li key={app._id} className="p-3 border rounded shadow-sm">
            <p><strong>Lawyer:</strong> {app.lawyerName}</p>
            <p><strong>Date:</strong> {new Date(app.date).toLocaleDateString()}</p>
            <p><strong>Status:</strong> {app.status}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
